<div class="header" (click)="handleToggle()" aria-hidden="true">
	<h3 class="section-title">{{title}}</h3>
	<app-svg [ngClass]="['toggle-expand', state]" svg="icons.svg#general--arrow--bottom" aria-hidden="true" [alt]="'Arrow bottom icon'"></app-svg>
</div>
<div class="body" role="list" [ngClass]="[state]">
	<div *ngIf="TAP_showLinks()">
		<div *ngFor="let option of options" role="listitem" class="extras-feature" [ngClass]="[state]">
			<div class="extras-feature__label">
				<a class="link" [ngClass]=option.classes (click)="TAP_linkClick(option)" href="javascript:;" role="button">{{option.label}}</a>
			</div>
		</div>
	</div>
	<div *ngIf="!TAP_showLinks()" [ngClass]="[state]" class="extras-feature">
		<span *ngIf="TAP_isGroupBooking()">
			This flight can't be changed because it's part of a group booking. If you wish to change your flight please <a href="javascript:;" class="link">contact</a> your travel agent.
		</span>
	</div>
	<div>
		<span class="muted-light" *ngIf="TAP_isSSREC()">Free of charge</span>
	</div>
</div>
